import { memo, useCallback } from 'react'
import { openShareTipsDrawer } from '../../app-state/modals/state.drawer'
import i18n from '../../utilities/i18n'
import Button from './Button'
import { buttonTipStyles } from './ButtonTipText'

interface IButtonShareTip {
    name: string
}

const ButtonShareTip = (props: IButtonShareTip) => {
    const { name } = props

    const handleOnClick = useCallback(() => {
        openShareTipsDrawer({ name })
    }, [name])

    return (
        <Button
            onClick={handleOnClick}
            data-testid="Button__ShareTip"
            size="small"
            css={buttonTipStyles}
        >
            {i18n.t('buttons.buttonShareTip')}
        </Button>
    )
}

export default memo(ButtonShareTip)
